// Lightweight LRU cache wrapper using quick-lru to keep Alpaca responses
// fresh while respecting rate-limits.

import QuickLRU from '@alloc/quick-lru';

const lru = new QuickLRU({ maxSize: 1_000, ttl: 60_000 }); // 1-minute TTL

export async function cached<T>(key: string, fn: () => Promise<T>): Promise<T> {
  if (lru.has(key)) {
    return lru.get(key) as T;
  }
  const val = await fn();
  lru.set(key, val);
  return val;
}

export { lru as inMemoryCache };
